const { render, useState } = wp.element;
import React, { Component } from "react";
import { withTranslation } from "react-i18next";
import { connect } from "react-redux";

//Import Designs
import {
    Grid2,
    AppBar,
    Toolbar,
    Button,
    Tooltip,
    Chip,
    SwipeableDrawer,
    Badge,
    TextField,
    Dialog,
    DialogContent,
    DialogActions,
    Menu,
    MenuItem,
    Box,
} from "@mui/material";
import SaveIcon from "@mui/icons-material/Save";
import CameraAltIcon from "@mui/icons-material/CameraAlt";
import StarIcon from "@mui/icons-material/Star";
import GavelIcon from "@mui/icons-material/Gavel";
import PersonIcon from "@mui/icons-material/Person";
import SearchIcon from "@mui/icons-material/Search";
import FormatListBulletedIcon from "@mui/icons-material/FormatListBulleted";
import AppsIcon from "@mui/icons-material/Apps";
import Loginpopup from "./Loginpopup.jsx";
import SortByAlphaIcon from "@mui/icons-material/SortByAlpha";
import MenuIcon from "@mui/icons-material/Menu";
import ExitToAppIcon from "@mui/icons-material/ExitToApp";
import dateFormat from "dateformat";
import Newsletter from "./Newsletter.jsx";

class VotingNavigation extends Component {
    constructor(props) {
        super(props);
        this.state = {
            fontcolor: "",
            hover_back: "",
            listcolor: "",
            gridcolor: "",
            btn_number: "",
            show_login: false,
            galleryfontcolor: null,
            galleryhover_back: null,
            tenfontcolor: null,
            tenhover_back: null,
            formfontcolor: null,
            formhover_back: null,
            rulesfontcolor: null,
            ruleshover_back: null,
            profilefontcolor: null,
            profilehover_back: null,
            searchfontcolor: null,
            searchhover_back: null,
            sortfontcolor: null,
            sorthover_back: null,
            sopen: false,
            sortopen: false,
            sortanchor: null,
        };
    }

    toggleHover = (value, name) => () => {
        switch (name) {
            case "submit_form":
                this.setState({
                    formfontcolor: value,
                    formhover_back:
                        this.props.vote_navbar_active_button_background,
                });
                break;
            case "gallery":
                this.setState({
                    galleryfontcolor: value,
                    galleryhover_back:
                        this.props.vote_navbar_active_button_background,
                });
                break;
            case "topten":
                this.setState({
                    tenfontcolor: value,
                    tenhover_back:
                        this.props.vote_navbar_active_button_background,
                });
                break;
            case "rules":
                this.setState({
                    rulesfontcolor: value,
                    ruleshover_back:
                        this.props.vote_navbar_active_button_background,
                });
                break;
            case "profile":
                this.setState({
                    profilefontcolor: value,
                    profilehover_back:
                        this.props.vote_navbar_active_button_background,
                });
                break;
            case "search":
                this.setState({
                    searchfontcolor: value,
                    searchhover_back:
                        this.props.vote_navbar_active_button_background,
                });
                break;
            case "sort":
                this.setState({
                    sortfontcolor: value,
                    sorthover_back:
                        this.props.vote_navbar_active_button_background,
                });
                break;
        }
    };

    toggleleave = (value, name) => () => {
        switch (name) {
            case "submit_form":
                this.setState({
                    formfontcolor: value,
                    formhover_back: null,
                });
                break;
            case "gallery":
                this.setState({
                    galleryfontcolor: value,
                    galleryhover_back: null,
                });
                break;
            case "topten":
                this.setState({
                    tenfontcolor: value,
                    tenhover_back: null,
                });
                break;
            case "rules":
                this.setState({
                    rulesfontcolor: value,
                    ruleshover_back: null,
                });
                break;
            case "profile":
                this.setState({
                    profilefontcolor: value,
                    profilehover_back: null,
                });
                break;
            case "search":
                this.setState({
                    searchfontcolor: value,
                    searchhover_back: null,
                });
                break;
            case "sort":
                this.setState({
                    sortfontcolor: value,
                    sorthover_back: null,
                });
                break;
        }
    };

    togglelistHover = (value, name) => () => {
        if (name == "list") this.setState({ listcolor: value });
        else this.setState({ gridcolor: value });
    };

    togglelistleave = (value, name) => () => {
        if (name == "list") this.setState({ listcolor: value });
        else this.setState({ gridcolor: value });
    };

    componentDidMount = () => {
        this.setState({
            galleryfontcolor: this.props.votes_navigation_text_color,
            tenfontcolor: this.props.votes_navigation_text_color,
            formfontcolor: this.props.votes_navigation_text_color,
            rulesfontcolor: this.props.votes_navigation_text_color,
            profilefontcolor: this.props.votes_navigation_text_color,
            searchfontcolor: this.props.votes_navigation_text_color,
            sortfontcolor: this.props.votes_navigation_text_color,
            listcolor: this.props.votes_list_inactive,
            gridcolor: this.props.votes_grid_inactive,
        });

        const override_view =
            typeof this.props.short !== "undefined"
                ? this.props.short.override_view
                : null;
        switch (override_view) {
            case "contest-gallery":
                this.props.handlegallery("gallery");
                break;
            case "contest-topten":
                this.props.handletopten("topten");
                break;
            case "contest-rules":
                this.props.handlerules("rules");
                break;
        }
    };

    handlelogin = () => {
        this.setState({ show_login: true });
    };

    handleClose = (event) => {
        this.setState({ show_login: false });
    };

    handleSearchClose = () => {
        this.setState({ sopen: false });
        this.setState({ search_error: false });
    };

    handleSearchtext = () => {
        const { wpvc_search } = this.props;
        this.props.searchclick(wpvc_search);
        this.handleSearchClose();
        this.props.handleDrawer(false);
    };

    handleClearSearch = () => {
        this.handleSearchClose();
        this.props.handleDrawer(false);
        this.props.searchclick("");
    };

    handleSearchOpen = () => {
        this.setState({ sopen: true });
    };

    handleSortOpen = (event) => {
        this.setState({ sortopen: true });
        this.setState({ sortanchor: event.currentTarget });
    };

    handleSortClose = () => {
        this.setState({ sortopen: false });
        this.setState({ sortanchor: null });
    };

    handleSorting = (event) => {
        this.props.handleDrawer(false);
        this.props.sortchange(event);
        this.handleSortClose();
    };

    calculateVoteTimeLeft(start_time) {
        let current_date = this.props.currentdate;
        if (!current_date) {
            current_date = new Date();
        }
        if (start_time != null) {
            start_time = start_time.replace(/ /g, "T");
            // var dateFormat = require("dateformat");
            var start_Date = dateFormat(start_time);
            let difference = new Date(start_Date) - current_date;
            return difference;
        } else {
            return -1;
        }
    }

    render() {
        const { t, i18n } = this.props;
        const {
            votes_navigation_font_size,
            votes_navigation_text_color,
            votes_navigation_text_color_hover,
            votes_navigationbgcolor,
            votes_list_active,
            votes_list_inactive,
            votes_grid_active,
            votes_grid_inactive,
            vote_navbar_active_button_background,
            vote_navbar_mobile_font,
        } = this.props;
        const allprops = this.props;

        let end_time = this.props.short.end_time;
        let start_time = this.props.short.start_time;
        let contest_rules = "";
        let timer = null;
        let showform = 0;
        let pagin_val_prop =
            typeof allprops.pagin_val !== "undefined"
                ? allprops.pagin_val
                : null;
        let total_posts =
            pagin_val_prop != null ? pagin_val_prop.total_posts : 0;
        let tax_activationcount =
            allprops.short.allcatoption.tax_activationcount || 0;

        if (
            this.props.short.showform == 1 ||
            this.props.short.displayform == 1
        ) {
            showform = 1;
        } else if (!start_time) {
            showform = 1;
            if (
                tax_activationcount !== 0 &&
                parseInt(tax_activationcount) <= parseInt(total_posts)
            ) {
                showform = 0;
            }
        } else if (start_time) {
            showform = this.calculateVoteTimeLeft(start_time);
            if (
                tax_activationcount !== 0 &&
                parseInt(tax_activationcount) <= parseInt(total_posts)
            ) {
                showform = 0;
            }
        } else if (end_time) {
            showform = this.calculateVoteTimeLeft(end_time);
        }

        if (end_time) {
            timer = this.calculateVoteTimeLeft(end_time);
        }

        if (
            (this.props.short.showform != 1 ||
                this.props.short.displayform != 1) &&
            tax_activationcount !== 0 &&
            parseInt(tax_activationcount) <= parseInt(total_posts)
        ) {
            timer = -1;
        }

        const onlyloggedsubmit = this.props.short.onlyloggedsubmit;
        const check_logged = this.props.short.user_logged;
        const get_view = this.props.view;

        let vote_count_showhide = null;
        let custom_link_gal = null;
        if (typeof this.props.short.allcatoption !== "undefined") {
            vote_count_showhide =
                this.props.short.allcatoption.style !== undefined
                    ? this.props.short.allcatoption.style.vote_count_showhide
                    : "";
            custom_link_gal = this.props.short.allcatoption
                .middle_custom_navigation
                ? this.props.short.allcatoption.middle_custom_navigation
                : null;
        }

        if (typeof this.props.short.allcatoption !== "undefined") {
            contest_rules = this.props.short.allcatoption.contest_rules;
        }

        let sortoptions = {};
        if (vote_count_showhide === "on") {
            sortoptions = {
                newest: t("newest"),
                oldest: t("oldest"),
                mostvoted: t("mostvoted"),
                leastvoted: t("leastvoted"),
            };
        } else {
            sortoptions = { newest: t("newest"), oldest: t("oldest") };
        }
        sortoptions = wp.hooks.applyFilters(
            "wpvc_judge_send_sorting",
            sortoptions,
            this.props
        );

        if (get_view != "profile_screen" && get_view != "topcontest") {
            const menuItems = (mobile = null) => {
                return (
                    <Grid2
                        container
                        className="wpvc_voting_nav_grid"
                        justifyContent="flex-start"
                    >
                        {this.props.short.showform !== "0" &&
                            this.props.short.displayform !== "0" &&
                            showform > 0 && (
                                <Grid2>
                                    {(onlyloggedsubmit == 0 ||
                                        check_logged == true) &&
                                        (this.props.short.showform === "1" ||
                                            this.props.short.displayform ===
                                                "1" ||
                                            timer > 0 ||
                                            timer == null) && (
                                            <Tooltip
                                                title={t("submit_entry")}
                                                placement="top-start"
                                            >
                                                <Button
                                                    className="wpvc_navigation"
                                                    onMouseOver={this.toggleHover(
                                                        votes_navigation_text_color_hover,
                                                        "submit_form"
                                                    )}
                                                    onMouseLeave={this.toggleleave(
                                                        votes_navigation_text_color,
                                                        "submit_form"
                                                    )}
                                                    onClickCapture={this.toggleleave(
                                                        null,
                                                        "submit_form"
                                                    )}
                                                    startIcon={<SaveIcon />}
                                                    size="small"
                                                    style={{
                                                        fontSize:
                                                            votes_navigation_font_size +
                                                            "px",
                                                        color:
                                                            mobile == 1
                                                                ? vote_navbar_mobile_font
                                                                : this.props
                                                                      .view ==
                                                                  "submit_form"
                                                                ? votes_navigation_text_color_hover
                                                                : this.state
                                                                      .formfontcolor,
                                                        backgroundColor:
                                                            this.props.view ==
                                                            "submit_form"
                                                                ? vote_navbar_active_button_background
                                                                : this.state
                                                                      .formhover_back,
                                                    }}
                                                    component="a"
                                                    href={wp.hooks.applyFilters(
                                                        "wpvc_submit_entry_url",
                                                        "#wpvc_navigation_bar_" +
                                                            this.props.short.id
                                                    )}
                                                    onClick={() => {
                                                        let value =
                                                            wp.hooks.applyFilters(
                                                                "wpvc_open_submit_form",
                                                                true
                                                            );
                                                        if (value) {
                                                            this.props.handleDrawer(
                                                                false
                                                            );
                                                            this.props.handleform(
                                                                "submit_form"
                                                            );
                                                        }
                                                    }}
                                                >
                                                    <span className="wpvc_nav_text">
                                                        {t("submit_entry")}
                                                    </span>
                                                </Button>
                                            </Tooltip>
                                        )}
                                    {onlyloggedsubmit == 1 &&
                                        check_logged == false &&
                                        (this.props.short.showform === "1" ||
                                            this.props.short.displayform ===
                                                "1" ||
                                            timer > 0 ||
                                            timer == null) && (
                                            <div>
                                                <Tooltip
                                                    title={t("submit_entry")}
                                                    placement="top-start"
                                                >
                                                    <Button
                                                        className="wpvc_navigation"
                                                        onMouseOver={this.toggleHover(
                                                            votes_navigation_text_color_hover,
                                                            "submit_form"
                                                        )}
                                                        onMouseLeave={this.toggleleave(
                                                            votes_navigation_text_color,
                                                            "submit_form"
                                                        )}
                                                        onClickCapture={this.toggleleave(
                                                            null,
                                                            "submit_form"
                                                        )}
                                                        startIcon={<SaveIcon />}
                                                        size="small"
                                                        style={{
                                                            fontSize:
                                                                votes_navigation_font_size +
                                                                "px",
                                                            color:
                                                                mobile == 1
                                                                    ? vote_navbar_mobile_font
                                                                    : this.props
                                                                          .view ==
                                                                      "submit_form"
                                                                    ? votes_navigation_text_color_hover
                                                                    : this.state
                                                                          .formfontcolor,
                                                            backgroundColor:
                                                                this.props
                                                                    .view ==
                                                                "submit_form"
                                                                    ? vote_navbar_active_button_background
                                                                    : this.state
                                                                          .formhover_back,
                                                        }}
                                                        component="a"
                                                        onClick={() => {
                                                            this.props.handleDrawer(
                                                                false
                                                            );
                                                            this.handlelogin();
                                                        }}
                                                    >
                                                        <span className="wpvc_nav_text">
                                                            {t("submit_entry")}
                                                        </span>
                                                    </Button>
                                                </Tooltip>
                                                <Loginpopup
                                                    {...allprops}
                                                    showlog={
                                                        this.state.show_login
                                                    }
                                                    handclose={this.handleClose}
                                                    handlog={this.handlelogin}
                                                />
                                            </div>
                                        )}
                                </Grid2>
                            )}

                        {(this.props.short.showgallery == 1 ||
                            this.props.short.showgallery == null) &&
                            this.props.view != "upcoming" && (
                                <Grid2>
                                    <Tooltip
                                        title={t("gallery")}
                                        placement="top-start"
                                    >
                                        <Button
                                            className="wpvc_navigation"
                                            onMouseOver={this.toggleHover(
                                                votes_navigation_text_color_hover,
                                                "gallery"
                                            )}
                                            onMouseLeave={this.toggleleave(
                                                votes_navigation_text_color,
                                                "gallery"
                                            )}
                                            onClickCapture={this.toggleleave(
                                                null,
                                                "gallery"
                                            )}
                                            startIcon={<CameraAltIcon />}
                                            size="small"
                                            style={{
                                                fontSize:
                                                    votes_navigation_font_size +
                                                    "px",
                                                color:
                                                    mobile == 1
                                                        ? vote_navbar_mobile_font
                                                        : this.props.view ==
                                                          "gallery"
                                                        ? votes_navigation_text_color_hover
                                                        : this.state
                                                              .galleryfontcolor,
                                                backgroundColor:
                                                    this.props.view == "gallery"
                                                        ? vote_navbar_active_button_background
                                                        : this.state
                                                              .galleryhover_back,
                                            }}
                                            href={
                                                custom_link_gal != null
                                                    ? custom_link_gal
                                                    : "#wpvc_navigation_bar_" +
                                                      this.props.short.id
                                            }
                                            component="a"
                                            onClick={() => {
                                                this.props.handleDrawer(false);
                                                this.props.handlegallery(
                                                    "gallery"
                                                );
                                            }}
                                        >
                                            <span className="wpvc_nav_text">
                                                {t("gallery")}
                                            </span>
                                        </Button>
                                    </Tooltip>
                                </Grid2>
                            )}

                        {this.props.short.showtop == 1 ||
                            (this.props.short.showtop == "on" && (
                                <Grid2>
                                    <Tooltip
                                        title={t("top_ten")}
                                        placement="top-start"
                                    >
                                        <Button
                                            className="wpvc_navigation"
                                            onMouseOver={this.toggleHover(
                                                votes_navigation_text_color_hover,
                                                "topten"
                                            )}
                                            onMouseLeave={this.toggleleave(
                                                votes_navigation_text_color,
                                                "topten"
                                            )}
                                            onClickCapture={this.toggleleave(
                                                null,
                                                "topten"
                                            )}
                                            startIcon={<StarIcon />}
                                            size="small"
                                            style={{
                                                fontSize:
                                                    votes_navigation_font_size +
                                                    "px",
                                                color:
                                                    mobile == 1
                                                        ? vote_navbar_mobile_font
                                                        : this.props.view ==
                                                          "topten"
                                                        ? votes_navigation_text_color_hover
                                                        : this.state
                                                              .tenfontcolor,
                                                backgroundColor:
                                                    this.props.view == "topten"
                                                        ? vote_navbar_active_button_background
                                                        : this.state
                                                              .tenhover_back,
                                            }}
                                            component="a"
                                            onClick={() => {
                                                this.props.handleDrawer(false);
                                                this.props.handletopten(
                                                    "topten"
                                                );
                                            }}
                                        >
                                            <span className="wpvc_nav_text">
                                                {t("top_ten")}
                                            </span>
                                        </Button>
                                    </Tooltip>
                                </Grid2>
                            ))}

                        {wp.hooks.applyFilters(
                            "wpvc_judge_topbar_navigation",
                            "",
                            this.props
                        )}

                        {(this.props.short.showrules == 1 ||
                            contest_rules != "") &&
                            this.props.show_all_rules != 0 &&
                            this.props.short.showrules !== "0" && (
                                <Grid2>
                                    <Tooltip
                                        title={t("rules")}
                                        placement="top-start"
                                    >
                                        <Button
                                            className="wpvc_navigation"
                                            onMouseOver={this.toggleHover(
                                                votes_navigation_text_color_hover,
                                                "rules"
                                            )}
                                            onMouseLeave={this.toggleleave(
                                                votes_navigation_text_color,
                                                "rules"
                                            )}
                                            onClickCapture={this.toggleleave(
                                                null,
                                                "rules"
                                            )}
                                            startIcon={<GavelIcon />}
                                            size="small"
                                            style={{
                                                fontSize:
                                                    votes_navigation_font_size +
                                                    "px",
                                                color:
                                                    mobile == 1
                                                        ? vote_navbar_mobile_font
                                                        : this.props.view ==
                                                          "rules"
                                                        ? votes_navigation_text_color_hover
                                                        : this.state
                                                              .rulesfontcolor,
                                                backgroundColor:
                                                    this.props.view == "rules"
                                                        ? vote_navbar_active_button_background
                                                        : this.state
                                                              .ruleshover_back,
                                            }}
                                            component="a"
                                            onClick={() => {
                                                this.props.handleDrawer(false);
                                                this.props.handlerules("rules");
                                            }}
                                        >
                                            <span className="wpvc_nav_text">
                                                {t("rules")}
                                            </span>
                                        </Button>
                                    </Tooltip>
                                </Grid2>
                            )}

                        {this.props.short.hideyourprofile != "on" &&
                            this.props.short.showprofile == 1 &&
                            this.props.short.user_logged == 1 && (
                                <Grid2>
                                    <Tooltip
                                        title={t("profile")}
                                        placement="top-start"
                                    >
                                        <Button
                                            className="wpvc_navigation"
                                            onMouseOver={this.toggleHover(
                                                votes_navigation_text_color_hover,
                                                "profile"
                                            )}
                                            onMouseLeave={this.toggleleave(
                                                votes_navigation_text_color,
                                                "profile"
                                            )}
                                            onClickCapture={this.toggleleave(
                                                null,
                                                "profile"
                                            )}
                                            startIcon={<PersonIcon />}
                                            size="small"
                                            style={{
                                                fontSize:
                                                    votes_navigation_font_size +
                                                    "px",
                                                color:
                                                    mobile == 1
                                                        ? vote_navbar_mobile_font
                                                        : this.props.view ==
                                                          "profile"
                                                        ? votes_navigation_text_color_hover
                                                        : this.state
                                                              .profilefontcolor,
                                                backgroundColor:
                                                    this.props.view == "profile"
                                                        ? vote_navbar_active_button_background
                                                        : this.state
                                                              .profilehover_back,
                                            }}
                                            component="a"
                                            onClick={() => {
                                                this.props.handleDrawer(false);
                                                this.props.handleurprofile(
                                                    "profile"
                                                );
                                            }}
                                        >
                                            <span className="wpvc_nav_text">
                                                {t("profile")}
                                            </span>
                                        </Button>
                                    </Tooltip>
                                </Grid2>
                            )}

                        <Grid2 className="wpvc_search_sort">
                            {this.props.short.search == 1 && (
                                <Grid2>
                                    <Tooltip
                                        title={t("Search")}
                                        placement="top-start"
                                    >
                                        <Button
                                            className="wpvc_search"
                                            size="small"
                                            aria-label="Search"
                                            component="span"
                                            onClick={this.handleSearchOpen}
                                            onMouseOver={this.toggleHover(
                                                votes_navigation_text_color_hover,
                                                "search"
                                            )}
                                            onMouseLeave={this.toggleleave(
                                                votes_navigation_text_color,
                                                "search"
                                            )}
                                            onClickCapture={this.toggleleave(
                                                null,
                                                "search"
                                            )}
                                            style={{
                                                fontSize:
                                                    votes_navigation_font_size +
                                                    "px",
                                                color:
                                                    mobile == 1
                                                        ? vote_navbar_mobile_font
                                                        : this.props.view ==
                                                          "search"
                                                        ? votes_navigation_text_color_hover
                                                        : this.state
                                                              .searchfontcolor,
                                                backgroundColor:
                                                    this.props.view == "search"
                                                        ? vote_navbar_active_button_background
                                                        : this.state
                                                              .searchhover_back,
                                            }}
                                            startIcon={
                                                <Badge
                                                    color="secondary"
                                                    variant="dot"
                                                    invisible={
                                                        this.props
                                                            .wpvc_search !==
                                                            undefined &&
                                                        this.props
                                                            .wpvc_search !==
                                                            "" &&
                                                        this.props
                                                            .wpvc_search_active ===
                                                            1
                                                            ? false
                                                            : true
                                                    }
                                                >
                                                    <SearchIcon
                                                        style={{
                                                            fontSize: "20px",
                                                        }}
                                                    />
                                                </Badge>
                                            }
                                        >
                                            <span className="wpvc_nav_text wpvc_search_text">
                                                {t("Search")}
                                            </span>
                                        </Button>
                                    </Tooltip>
                                    {this.props.wpvc_search !== undefined &&
                                        this.props.wpvc_search !== "" &&
                                        this.props.wpvc_search_active === 1 && (
                                            <Chip
                                                className="wpvc_search_chip"
                                                size="small"
                                                onDelete={
                                                    this.handleClearSearch
                                                }
                                                label={this.props.wpvc_search}
                                                variant="outlined"
                                                color="secondary"
                                                style={{ maxWidth: "150px" }}
                                            />
                                        )}
                                </Grid2>
                            )}

                            {this.props.short.sort_by == 1 &&
                                this.props.sortshow == 1 && (
                                    <Grid2>
                                        <Tooltip
                                            title={t("sort")}
                                            placement="top-start"
                                        >
                                            <Button
                                                className="wpvc_sorting"
                                                size="small"
                                                aria-label="Sort"
                                                component="span"
                                                onClick={this.handleSortOpen}
                                                onMouseOver={this.toggleHover(
                                                    votes_navigation_text_color_hover,
                                                    "sort"
                                                )}
                                                onMouseLeave={this.toggleleave(
                                                    votes_navigation_text_color,
                                                    "sort"
                                                )}
                                                onClickCapture={this.toggleleave(
                                                    null,
                                                    "sort"
                                                )}
                                                style={{
                                                    fontSize:
                                                        votes_navigation_font_size +
                                                        "px",
                                                    color:
                                                        mobile == 1
                                                            ? vote_navbar_mobile_font
                                                            : this.props.view ==
                                                              "sort"
                                                            ? votes_navigation_text_color_hover
                                                            : this.state
                                                                  .sortfontcolor,
                                                    backgroundColor:
                                                        this.props.view ==
                                                        "sort"
                                                            ? vote_navbar_active_button_background
                                                            : this.state
                                                                  .sorthover_back,
                                                }}
                                                startIcon={
                                                    <SortByAlphaIcon
                                                        style={{
                                                            fontSize: "20px",
                                                        }}
                                                    />
                                                }
                                            >
                                                <span className="wpvc_nav_text wpvc_search_text">
                                                    {t("sort")}
                                                </span>
                                            </Button>
                                        </Tooltip>
                                        <Menu
                                            open={this.state.sortopen}
                                            anchorEl={this.state.sortanchor}
                                            onClose={this.handleSortClose}
                                        >
                                            {Object.keys(sortoptions).map(
                                                (key, index) => (
                                                    <MenuItem
                                                        key={index}
                                                        data-value={key}
                                                        selected={
                                                            key ===
                                                            this.props.sortselect()
                                                        }
                                                        onClick={
                                                            this.handleSorting
                                                        }
                                                    >
                                                        {t(key)}
                                                    </MenuItem>
                                                )
                                            )}
                                        </Menu>
                                    </Grid2>
                                )}
                        </Grid2>
                    </Grid2>
                );
            };

            return (
                <Grid2 container size={12} className="wpvc_voting_navigation">
                    <Grid2
                        container
                        size={12}
                        className="wpvc_navigation_bar"
                        id={"wpvc_navigation_bar_" + this.props.short.id}
                    >
                        <AppBar
                            position="static"
                            className="wpvc_app_bar"
                            style={{ backgroundColor: votes_navigationbgcolor }}
                            enableColorOnDark
                        >
                            <Toolbar disableGutters={false}>
                                <Grid2
                                    container
                                    size={12}
                                    justifyContent="space-between"
                                >
                                    {this.props?.short?.addcontestshortcode ===
                                    1 ? (
                                        <Box>{menuItems()}</Box>
                                    ) : (
                                        <Box
                                            sx={{
                                                display: {
                                                    xs: "none",
                                                    md: "block",
                                                },
                                            }}
                                        >
                                            {menuItems()}
                                        </Box>
                                    )}

                                    {this.props?.short?.addcontestshortcode ===
                                        undefined && (
                                        <Box
                                            sx={{
                                                display: {
                                                    md: "none",
                                                    xs: "block",
                                                },
                                            }}
                                        >
                                            <Grid2
                                                container
                                                className="wpvc_voting_nav_grid"
                                                justifyContent="flex-start"
                                            >
                                                <Button
                                                    className="wpvc_navi_grid_list"
                                                    startIcon={<MenuIcon />}
                                                    size="large"
                                                    component="a"
                                                    style={{
                                                        fontSize:
                                                            votes_navigation_font_size +
                                                            "px",
                                                        color: votes_navigation_text_color,
                                                    }}
                                                    onClick={() =>
                                                        this.props.handleDrawer(
                                                            true
                                                        )
                                                    }
                                                >
                                                    {t("Menu")}
                                                </Button>
                                                <SwipeableDrawer
                                                    anchor="left"
                                                    open={
                                                        allprops.drawer || false
                                                    }
                                                    onClose={() =>
                                                        this.props.handleDrawer(
                                                            false
                                                        )
                                                    }
                                                    onOpen={() =>
                                                        this.props.handleDrawer(
                                                            true
                                                        )
                                                    }
                                                >
                                                    {menuItems(1)}
                                                </SwipeableDrawer>
                                            </Grid2>
                                        </Box>
                                    )}

                                    <Grid2
                                        container
                                        direction="row"
                                        className="wpvc_grid_list"
                                        justifyContent="flex-end"
                                        style={{ flexWrap: "nowrap" }}
                                    >
                                        {check_logged && (
                                            <Grid2>
                                                <Tooltip
                                                    title={t("Logout")}
                                                    placement="top-start"
                                                >
                                                    <Button
                                                        className="wpvc_navi_grid_list"
                                                        startIcon={
                                                            <ExitToAppIcon />
                                                        }
                                                        size="large"
                                                        component="a"
                                                        style={{
                                                            fontSize:
                                                                votes_navigation_font_size +
                                                                "px",
                                                            color: "#FEFEFE",
                                                        }}
                                                        onClick={
                                                            this.props
                                                                .handlelogout
                                                        }
                                                    >
                                                        <span
                                                            className="wpvc_nav_text wpvc_search_text"
                                                            style={{
                                                                marginRight:
                                                                    "8px",
                                                                marginLeft:
                                                                    "-8px",
                                                            }}
                                                        >
                                                            {t("Logout")}
                                                        </span>
                                                    </Button>
                                                </Tooltip>
                                            </Grid2>
                                        )}

                                        {this.props.short.allcatoption
                                            .list_grid_hide != "on" &&
                                            this.props.hide_grid == 1 &&
                                            this.props.view != "upcoming" && (
                                                <>
                                                    <Grid2>
                                                        <Button
                                                            className="wpvc_navi_grid_list"
                                                            startIcon={
                                                                <FormatListBulletedIcon />
                                                            }
                                                            size="large"
                                                            component="a"
                                                            onMouseOver={this.togglelistHover(
                                                                votes_list_active,
                                                                "list"
                                                            )}
                                                            onMouseLeave={this.togglelistleave(
                                                                votes_list_inactive,
                                                                "list"
                                                            )}
                                                            style={{
                                                                fontSize:
                                                                    votes_navigation_font_size +
                                                                    "px",
                                                                color:
                                                                    this.props
                                                                        .view ==
                                                                    "list"
                                                                        ? votes_list_active
                                                                        : this
                                                                              .state
                                                                              .listcolor,
                                                            }}
                                                            onClick={() => {
                                                                this.props.handleview(
                                                                    "list"
                                                                );
                                                            }}
                                                        ></Button>
                                                    </Grid2>
                                                    <Grid2>
                                                        <Button
                                                            className="wpvc_navi_grid_list"
                                                            startIcon={
                                                                <AppsIcon />
                                                            }
                                                            size="large"
                                                            component="a"
                                                            onMouseOver={this.togglelistHover(
                                                                votes_grid_active,
                                                                "grid"
                                                            )}
                                                            onMouseLeave={this.togglelistleave(
                                                                votes_grid_inactive,
                                                                "grid"
                                                            )}
                                                            style={{
                                                                fontSize:
                                                                    votes_navigation_font_size +
                                                                    "px",
                                                                color:
                                                                    this.props
                                                                        .view ==
                                                                    "grid"
                                                                        ? votes_grid_active
                                                                        : this
                                                                              .state
                                                                              .gridcolor,
                                                            }}
                                                            onClick={() => {
                                                                this.props.handleview(
                                                                    "grid"
                                                                );
                                                            }}
                                                        ></Button>
                                                    </Grid2>
                                                </>
                                            )}
                                    </Grid2>
                                </Grid2>
                            </Toolbar>
                        </AppBar>

                        <Newsletter {...this.props} />

                        {this.props.short.search == 1 && (
                            <Dialog
                                fullWidth={true}
                                maxWidth="sm"
                                open={this.state.sopen}
                                onClose={this.handleSearchClose}
                                aria-labelledby="Search Dialog"
                            >
                                <DialogContent>
                                    <TextField
                                        autoFocus
                                        margin="dense"
                                        name="wpvc_search"
                                        label={t("Search")}
                                        fullWidth
                                        onChange={this.props.searchchange()}
                                        value={this.props.wpvc_search || ""}
                                        variant="standard"
                                    />
                                </DialogContent>
                                <DialogActions>
                                    <Button
                                        onClick={this.handleClearSearch}
                                        color="secondary"
                                    >
                                        {t("Reset")}
                                    </Button>
                                    <Button
                                        onClick={this.handleSearchtext}
                                        color="primary"
                                    >
                                        {t("Search")}
                                    </Button>
                                </DialogActions>
                            </Dialog>
                        )}
                    </Grid2>
                </Grid2>
            );
        } else {
            return "";
        }
    }
}

export default connect()(withTranslation("translations")(VotingNavigation));
